import { createContext, useCallback, useContext, useState, useEffect } from 'react';

// Emitter simples para disparar toasts fora da árvore React (ex: interceptors axios)
export const toastEmitter = {
  _handlers: [],
  on(fn) { this._handlers.push(fn); return () => { this._handlers = this._handlers.filter(h => h !== fn); }; },
  emit(payload) { this._handlers.forEach(h => { try { h(payload); } catch(_){} }); }
};

const ToastCtx = createContext();

let idSeq = 0;

export function ToastProvider({ children }) {
  const [toasts,setToasts] = useState([]);
  const push = useCallback((type, message) => {
    const id = ++idSeq;
    setToasts(t => [...t, { id, type, message }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }, []);
  // Assina eventos externos
  useEffect(() => {
    const off = toastEmitter.on(({ type, message }) => push(type, message));
    return off;
  }, [push]);
  const api = {
    success: (m) => push('success', m),
    error: (m) => push('error', m),
    info: (m) => push('info', m)
  };
  return (
    <ToastCtx.Provider value={api}>
      {children}
      <div style={{position:'fixed', top:10, right:10, display:'flex', flexDirection:'column', gap:8, zIndex:9999}}>
        {toasts.map(t => <div key={t.id} style={toastStyle(t.type)}>{t.message}</div>)}
      </div>
    </ToastCtx.Provider>
  );
}

function toastStyle(type) {
  const colors = { success: 'var(--color-blue)', error: 'var(--color-primary)', info: 'var(--color-orange)' };
  return { background: colors[type] || '#333', color:'#fff', padding:'0.6rem 0.9rem', fontSize:'.75rem', borderRadius:6, boxShadow:'var(--shadow-md)', maxWidth:'260px' };
}

export function useToast() { return useContext(ToastCtx); }
